export default __webpack_public_path__ + "static/media/pingasor.76585993.svg";